import { GET_E_WAYBILL_API_URL } from "../components/Shared/constant";

const FetchEWayBillAPI = (params, accessToken) => {
  const responce = window.axios
    .get(GET_E_WAYBILL_API_URL, {
      params,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: "Bearer " + accessToken,
      },
    })
    .then(function (result) {
      return {
        ...result.data,
        status: 200,
      };
    })
    .catch(function (result) {
      return {
        ...result?.response?.data,
        status: result?.response?.status,
      };
    });
  return responce;
};

export default FetchEWayBillAPI;
